<template>
  <div>
    <a-card class="customer-filter" size="small">
      <problem-filter-form v-model="filterForm" @change="onSearch" @reset="handleReset" />
    </a-card>
    <a-card title="问题列表" class="filter-data" size="small">
      <span slot="extra">
        <a-space>
          <a-button v-has="{ code: 'event:problem:sendReport' }" class="handle-menu" type="primary" icon="notification" :disabled="!selectedIds.length" @click="onSendReport">发送报告</a-button>
          <a-button v-tc="{ name: '添加问题' }" class="handle-menu" type="primary" icon="plus" @click="onAdd">添加</a-button>
        </a-space>
      </span>
      <problem-data-list :loading="loading" :table-data="tableData" :pagination="pagination" @page-change="handleTableChange" @edit="onEdit" @to-fault="onToFault" @reload="getProblemList" @selection-change="handleSelectionChange" />
    </a-card>
    <problem-modal ref="problemModal" @close="getProblemList" />
    <fault-drawer :display="faultVisible" :source-id="sourceId" @close="close" />
    <problem-push-report-modal ref="messagePushModal" @success="handleMessagePushSuccess" />
  </div>
</template>

<script>
import { problemList } from '@/api/event/problem';

import FaultDrawer from '@/pages/event/components/FaultDrawer';
import ProblemModal from '@/pages/event/components/ProblemModal';
import ProblemDataList from '@/pages/event/components/ProblemDataList';
import ProblemFilterForm from '@/pages/event/components/ProblemFilterForm';
import ProblemPushReportModal from '@/pages/event/components/ProblemPushReportModal';

export default {
  name: 'ProblemIndex',
  components: {
    ProblemModal,
    FaultDrawer,
    ProblemDataList,
    ProblemFilterForm,
    ProblemPushReportModal
  },
  data() {
    return {
      loading: false,
      sourceId: null,
      selectedIds: [],
      messagePushVisible: false,
      filterForm: {
        title: null,
        time_field: 'reported_time'
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: this.$store.getters.pageSize,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: total => `共 ${total} 条`
      },
      faultVisible: false,
      tableData: []
    };
  },
  mounted() {
    this.getProblemList();
  },
  methods: {
    onAdd() {
      this.$nextTick(() => {
        this.$refs.problemModal.openAdd();
      });
    },

    onEdit(record) {
      this.$nextTick(() => {
        this.$refs.problemModal.openEdit(record.id);
      });
    },

    onToFault(record) {
      this.sourceId = record.id;
      this.faultVisible = true;
    },

    /**
     * 获取问题列表
     */
    getProblemList() {
      this.loading = true;
      problemList({ ...this.filterForm, page_size: this.pagination.pageSize, page_number: this.pagination.current })
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleReset() {
      this.pagination.current = 1;
      this.pagination.pageSize = this.$store.getters.pageSize;
      this.filterForm = {
        time_field: 'reported_time'
      };
      this.getProblemList();
    },

    onSearch(filter) {
      this.filterForm = { ...filter };
      this.filterForm.page_number = 1;
      this.getProblemList();
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getProblemList();
    },

    close(type) {
      this.faultVisible = false;
      if (type === 'submit') {
        this.getProblemList();
      }
    },

    handleSelectionChange(selectedRowKeys) {
      this.selectedIds = selectedRowKeys;
    },

    onSendReport() {
      this.utils.trackClick({ name: '点击发送生产问题报告' });
      const selectedProblems = this.tableData.filter(item => this.selectedIds.includes(item.id));
      this.$nextTick(() => {
        this.$refs.messagePushModal.open(selectedProblems);
      });
    },

    handleMessagePushSuccess(data) {
      // TODO: 处理发送报告成功后的逻辑
      this.$message.success('报告发送成功');
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.customer-filter) {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
}
</style>
